import { render, staticRenderFns } from "./FileV3.vue?vue&type=template&id=7ad69cd2&scoped=true"
import script from "./FileV3.vue?vue&type=script&lang=js"
export * from "./FileV3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad69cd2",
  null
  
)

export default component.exports